import { render, staticRenderFns } from "./Libro.vue?vue&type=template&id=618a1dc5"
import script from "./Libro.vue?vue&type=script&lang=js"
export * from "./Libro.vue?vue&type=script&lang=js"
import style0 from "./Libro.vue?vue&type=style&index=0&id=618a1dc5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports